import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchProfile, submitMarketingConsent } from './sessionApi';

const initialState = {
  loading: false,
  success: false,
  error: null,
  user: {},
  publicId: null,
  showNavBar: true,
  previousRoute: null,
  submittingMarketingConsent: false,
};

export const fetchProfileThunk = createAsyncThunk('session/fetchProfile', async (_, { rejectWithValue }) => {
  try {
    const data = await fetchProfile();

    if (data.redirect_url) {
      window.location = data.redirect_url;
    }

    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const submitMarketingConsentThunk = createAsyncThunk(
  'session/submitMarketingConsent',
  async ({ phone, marketing_consent, publicId }, { rejectWithValue }) => {
    try {
      const data = await submitMarketingConsent({ phone, marketing_consent, publicId });

      if (!data.success) {
        return rejectWithValue(data.message || 'Failed to submit consent');
      }

      return { marketing_consent: true, phone };
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setRouteContext(state, { payload }) {
      state.publicId = payload.publicId;
      state.showNavBar = payload.showNavBar;
    },
    setPreviousRoute(state, { payload }) {
      state.previousRoute = payload;
    },
    clearSessionError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfileThunk.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(fetchProfileThunk.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.user = payload;
      })
      .addCase(fetchProfileThunk.rejected, (state, { payload, error }) => {
        state.loading = false;
        state.success = false;
        state.error = payload || error;
      })
      .addCase(submitMarketingConsentThunk.pending, (state) => {
        state.submittingMarketingConsent = true;
      })
      .addCase(submitMarketingConsentThunk.fulfilled, (state, { payload }) => {
        state.submittingMarketingConsent = false;
        state.user = { ...state.user, ...payload };
      })
      .addCase(submitMarketingConsentThunk.rejected, (state, { payload, error }) => {
        state.submittingMarketingConsent = false;
        state.error = payload || error;
      });
  },
});

export const { clearSessionError, setPreviousRoute, setRouteContext } = sessionSlice.actions;

export default sessionSlice.reducer;
